const toggleClass = (element, className, add) => {
    if (element) {
        if (add) {
            element.classList.add(className);
        } else {
            element.classList.remove(className);
        }
    }
};

const addEventListener = (element, event, handler) => {
    if (element && typeof element.addEventListener === 'function') {
        element.addEventListener(event, handler);
    } else if (element && element.length !== undefined) {
        Array.from(element).forEach(el => {
            if (el && typeof el.addEventListener === 'function') {
                el.addEventListener(event, handler);
            }
        });
    }
}

const dispatchCustomEvent = (eventName) => {
    const event = new Event(eventName);
    document.dispatchEvent(event);
};

const getElement = (id) => document.getElementById(id);
const getElementsByClassName = (name) => document.getElementsByClassName(name);

const openSlider = (id) => {
    const element = getElement(id);
    toggleClass(element, "-translate-x-full", false);
    toggleClass(element, "translate-x-0", true);
};

const openBottomSlider = (id) => {
    const element = getElement(id);
    toggleClass(element, "translate-y-full", false);
    toggleClass(element, "translate-y-0", true);
}

const closeBottomSlider = (id) => {
    const element = getElement(id);
    toggleClass(element, "translate-y-full", true);
    toggleClass(element, "translate-y-0", false);
}

const closeSlider = (id) => {
    const element = getElement(id);
    toggleClass(element, "translate-x-0", false);
    toggleClass(element, "-translate-x-full", true);
}

const scrollContainer = (id, pixels) => {
    const sliderContainer = getElement(id);
    if (sliderContainer) {
        sliderContainer.scrollBy({ left: pixels, behavior: 'smooth' });
    }
}

const goToLink = (link) => {
    window.location.href = link;
}
